module.exports = __webpack_public_path__ + "img/sq-12.5d5abd1d.jpg";